<footer id="footer" class="bg-[#00433c] text-iwan-primary-light py-8 mt-auto">
  <div class="container">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
      <div class="md:col-span-3">
        <div class="logocontainer">
          <img src="assets/images/logo_white.png" alt="Iwan" class="h-12 w-auto mb-3" />
          <p class="text-sm opacity-90">{{ 'footer.description' | translate }}</p>
        </div>
        <div class="iwan-footer-lang mt-2 flex items-center gap-1 text-sm cursor-pointer" (click)="language.toggleLang()">
          <span>{{ language.currentLang === 'ar' ? 'EN' : 'العربية' }}</span>
        </div>
      </div>
      <div class="md:col-span-5">
        <div class="grid grid-cols-2 gap-4 mt-4 md:mt-0">
          <ul class="footerUL list-none p-0 m-0 space-y-2">
            <li><a routerLink="/books" class="text-inherit no-underline hover:underline">{{ 'nav.books' | translate }}</a></li>
            <li><a routerLink="/writer-plans" class="text-inherit no-underline hover:underline">{{ 'nav.publish' | translate }}</a></li>
            <li><a routerLink="/famous-writers" class="text-inherit no-underline hover:underline">{{ 'nav.famousWriters' | translate }}</a></li>
          </ul>
          <ul class="footerUL list-none p-0 m-0 space-y-2">
            <li><a routerLink="/about" class="text-inherit no-underline hover:underline">{{ 'nav.about' | translate }}</a></li>
            <li><a routerLink="/blog" class="text-inherit no-underline hover:underline">{{ 'nav.blog' | translate }}</a></li>
            <li><a routerLink="/contact" class="text-inherit no-underline hover:underline">{{ 'nav.contact' | translate }}</a></li>
            <li><a routerLink="/publishing-services" class="text-inherit no-underline hover:underline">{{ 'nav.publishingServices' | translate }}</a></li>
          </ul>
        </div>
      </div>
      <div class="md:col-span-4 mt-4 md:mt-0">
        <div class="lastcontainer">
          <img src="assets/images/logo_white.png" alt="Iwan" class="h-14 w-auto mb-2" />
          <p class="font-semibold text-sm">{{ 'footer.downloadAppTitle' | translate }}</p>
          <small class="block text-xs opacity-80 mb-3">{{ 'footer.downloadAppDesc' | translate }}</small>
          <div class="downloadBtns flex gap-2">
            <a href="#" target="_blank" rel="noopener" class="opacity-90 hover:opacity-100"><img src="assets/images/appstore.png" alt="App Store" class="h-10 w-auto" onerror="this.style.display='none'" /></a>
            <a href="#" target="_blank" rel="noopener" class="opacity-90 hover:opacity-100"><img src="assets/images/googleplay.png" alt="Google Play" class="h-10 w-auto" onerror="this.style.display='none'" /></a>
          </div>
        </div>
      </div>
    </div>
    <p class="copyright text-center md:text-left text-sm opacity-80 mt-8 pt-6 border-t border-white/20">&copy; {{ currentYear }} Iwan. {{ 'footer.rights' | translate }}</p>
  </div>
</footer>
